import { Link } from 'react-router-dom';

const LOGO_URL =
  'https://pub-67931846c43548b18bfbc16e1101b0c6.r2.dev/client%20images%20uploads/bharat-consultancy/Final_logo_bharat_consultancy(1).jpg%20(1).jpeg';

const SERVICE_LINKS = [
  { to: '/services/gst-registration', label: 'GST Registration' },
  { to: '/services/msme-registration', label: 'MSME Registration' },
  { to: '/services/income-tax-return-filing', label: 'Income Tax Return Filing' },
  { to: '/services/trade-license', label: 'Trade License' },
  { to: '/services/company-registration', label: 'Company Registration' },
];

const LOCATION_LINKS = [
  { to: '/gst-registration-purulia', label: 'GST Registration in Purulia' },
  { to: '/msme-registration-purulia', label: 'MSME Registration in Purulia' },
  { to: '/itr-filing-purulia', label: 'ITR Filing in Purulia' },
  { to: '/trade-license-purulia', label: 'Trade License in Purulia' },
];

export function Footer() {
  return (
    <footer className="border-t border-line bg-white">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            {/* Same fix as Header.tsx: the logo file already includes
                the "Bharat Consultancy" wordmark, so it's shown at its
                natural aspect ratio (no crop) with no duplicate text
                heading next to it. */}
            <img src={LOGO_URL} alt="Bharat Consultancy" className="h-12 w-auto object-contain" />
            <p className="mt-3 text-sm text-ink/60">Trusted Tax &amp; Accounting Professional</p>
            <address className="mt-4 text-sm text-ink/70 not-italic leading-relaxed">
              2nd Floor, Aradhya Complex, SN Sarkar St,
              <br />
              Munsifdanga, Purulia, West Bengal 723101
            </address>
            <p className="mt-3 text-sm text-ink/70">
              Phone:{' '}
              <a href="tel:+918170896296" className="hover:text-seal-blue">
                81708 96296
              </a>
            </p>
            <p className="text-sm text-ink/70">
              WhatsApp:{' '}
              <a href="https://wa.me/918170896296" className="hover:text-seal-blue">
                81708 96296
              </a>
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-ink/50">Services</h4>
            <ul className="mt-4 space-y-2">
              {SERVICE_LINKS.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-ink/70 hover:text-seal-blue">
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/services" className="text-sm font-medium text-seal-blue">
                  View all services →
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-ink/50">Service Areas</h4>
            <ul className="mt-4 space-y-2">
              {LOCATION_LINKS.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-ink/70 hover:text-seal-blue">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-ink/50">Company</h4>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/about" className="text-sm text-ink/70 hover:text-seal-blue">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-ink/70 hover:text-seal-blue">
                  Contact Us
                </Link>
              </li>
              {/* All four link to the same /terms page's respective
                  section — the client's doc lists them as separate
                  footer items, but the content lives on one combined
                  legal page (see Terms.tsx) rather than four separate
                  routes, since the sections are short and related. */}
              <li>
                <Link to="/terms" className="text-sm text-ink/70 hover:text-seal-blue">
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-ink/70 hover:text-seal-blue">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-ink/70 hover:text-seal-blue">
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-ink/70 hover:text-seal-blue">
                  Disclaimer
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-sm font-medium text-seal-blue hover:text-seal-blue-dark">
                  Customer Dashboard
                </Link>
              </li>
              <li>
                <Link to="/admin" className="text-sm text-ink/50 hover:text-ink/80">
                  Admin Login
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="stub-divider mt-10 pt-6 text-center text-sm text-ink/50">
          © {new Date().getFullYear()} Bharat Consultancy. All rights reserved.
          <br />
          <span className="mt-1 inline-block">
            Made with love by{' '}
            <a
              href="https://www.bizzness.in"
              target="_blank"
              rel="noreferrer"
              className="font-medium text-marigold hover:underline"
            >
              team Bizzness
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
